"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TransactionType = exports.TransactionStatus = exports.TherapyOption = exports.THERAPY_BOOKING_NO_SHOW_PRICE_AMOUNT = exports.PaymentType = exports.PHYSICIAN_BOOKING_NO_SHOW_PRICE_AMOUNT = exports.INSURANCE_THERAPY_BOOKING_NO_SHOW_PRICE_AMOUNT = exports.INSURANCE_THERAPY_BOOKING_LATE_CHANGE_PRICE_AMOUNT = exports.INSURANCE_PHYSICIAN_BOOKING_NO_SHOW_PRICE_AMOUNT = exports.INSURANCE_PHYSICIAN_BOOKING_LATE_CHANGE_PRICE_AMOUNT = exports.DEFAULT_COST_PER_THERAPIST_APPOINTMENT = exports.DEFAULT_COST_PER_PHYSICIAN_APPOINTMENT = exports.BOOKING_LATE_CHANGE_PRICE_AMOUNT = void 0;
var PaymentType = {
  Insurance: 'insurance',
  Cash: 'cash',
  All: 'all'
};
exports.PaymentType = PaymentType;
var TherapyOption = /*#__PURE__*/function (TherapyOption) {
  TherapyOption["Weekly"] = "weekly";
  TherapyOption["Biweekly"] = "biweekly";
  TherapyOption["None"] = "none";
  return TherapyOption;
}({});
exports.TherapyOption = TherapyOption;
var THERAPY_BOOKING_NO_SHOW_PRICE_AMOUNT = 5000; // in cents
exports.THERAPY_BOOKING_NO_SHOW_PRICE_AMOUNT = THERAPY_BOOKING_NO_SHOW_PRICE_AMOUNT;
var PHYSICIAN_BOOKING_NO_SHOW_PRICE_AMOUNT = 5000;
exports.PHYSICIAN_BOOKING_NO_SHOW_PRICE_AMOUNT = PHYSICIAN_BOOKING_NO_SHOW_PRICE_AMOUNT;
var INSURANCE_THERAPY_BOOKING_NO_SHOW_PRICE_AMOUNT = 12500;
exports.INSURANCE_THERAPY_BOOKING_NO_SHOW_PRICE_AMOUNT = INSURANCE_THERAPY_BOOKING_NO_SHOW_PRICE_AMOUNT;
var INSURANCE_PHYSICIAN_BOOKING_NO_SHOW_PRICE_AMOUNT = 10000;
exports.INSURANCE_PHYSICIAN_BOOKING_NO_SHOW_PRICE_AMOUNT = INSURANCE_PHYSICIAN_BOOKING_NO_SHOW_PRICE_AMOUNT;
var INSURANCE_THERAPY_BOOKING_LATE_CHANGE_PRICE_AMOUNT = 12500;
exports.INSURANCE_THERAPY_BOOKING_LATE_CHANGE_PRICE_AMOUNT = INSURANCE_THERAPY_BOOKING_LATE_CHANGE_PRICE_AMOUNT;
var INSURANCE_PHYSICIAN_BOOKING_LATE_CHANGE_PRICE_AMOUNT = 10000;
exports.INSURANCE_PHYSICIAN_BOOKING_LATE_CHANGE_PRICE_AMOUNT = INSURANCE_PHYSICIAN_BOOKING_LATE_CHANGE_PRICE_AMOUNT;
var BOOKING_LATE_CHANGE_PRICE_AMOUNT = 2500;
exports.BOOKING_LATE_CHANGE_PRICE_AMOUNT = BOOKING_LATE_CHANGE_PRICE_AMOUNT;
var DEFAULT_COST_PER_THERAPIST_APPOINTMENT = 12500; // $125.00
exports.DEFAULT_COST_PER_THERAPIST_APPOINTMENT = DEFAULT_COST_PER_THERAPIST_APPOINTMENT;
var DEFAULT_COST_PER_PHYSICIAN_APPOINTMENT = 10000;

// ---- TRANSACTIONS Based on the possible values from the backend get transactions query ----
exports.DEFAULT_COST_PER_PHYSICIAN_APPOINTMENT = DEFAULT_COST_PER_PHYSICIAN_APPOINTMENT;
var TransactionType = {
  // StripePaymentType, sans parent types
  Copayment: 'copayment',
  Coinsurance: 'coinsurance',
  CopayAdjustment: 'copay-adjustment',
  Deductible: 'deductible',
  PatientResponsibility: 'patient-responsibility',
  InsuranceDenied: 'insurance-denied',
  LateCancellationFee: 'late-cancellation-fee',
  LateRescheduleFee: 'late-reschedule-fee',
  MissedAppointment: 'missed-appointment-fee',
  PerAppointmentFee: 'per-appointment-fee',
  Subscription: 'subscription',
  SubscriptionUpdate: 'subscription-update',
  InsuranceDeposit: 'insurance-deposit',
  CashpayDeposit: 'cashpay-deposit',
  // The only type for a refund
  Refund: 'refund'
};
exports.TransactionType = TransactionType;
var TransactionStatus = {
  // StripeRefundStatus
  Pending: 'pending',
  // Used instead of InvoicePaymentStatus.Unpaid
  Succeeded: 'succeeded',
  // Used instead of InvoicePaymentStatus.Paid
  RequiresAction: 'requires_action',
  Failed: 'failed',
  Canceled: 'canceled',
  // Derived type
  Retrying: 'retrying'
};
exports.TransactionStatus = TransactionStatus;